export const PLACE_GUIDE_LABELS = { reviews: 'What people say', order: 'What to order', atmosphere: 'What it’s like', highlights: 'Highlights', tips: 'Good to know' };

export function placeGuideText(place, guide) {
  const lines = [place.title];
  const meta = [typeof place.rating === 'number' ? `${place.rating.toFixed(1)} stars` : '', place.type, place.price].filter(Boolean);
  if (meta.length) lines.push(meta.join(' · '));
  if (place.address) lines.push(`Address: ${place.address}`);
  if (place.phone) lines.push(`Phone: ${place.phone}`);
  if (place.website) lines.push(`Website: ${place.website}`);
  if (place.hours?.length) lines.push('', 'Opening hours', ...place.hours.map(row => `${row.day}: ${row.hours}`));
  if (guide?.overview?.text) lines.push('', guide.overview.text);
  for (const section of guide?.sections || []) {
    if (!PLACE_GUIDE_LABELS[section.key] || !section.items?.length) continue;
    lines.push('', PLACE_GUIDE_LABELS[section.key], ...section.items.map(item => `• ${item.text}`));
  }
  return lines.join('\n');
}
